module.exports = __webpack_public_path__ + "img/BS39.0c09bacf.svg";